import Icon from "./icons/Icon";
import "./SpielKopf.css";

/**
 * Kopf jedes Spiel-Bildschirms: links Runde (oder Spielstand), dann die
 * Punkte-Pille, rechts Verlauf und Menue. Immer gleich aufgebaut.
 * hinweis: kleiner Zusatz unter der Runde (z. B. Raum-Verbindung).
 * @category spiel
 */
export function SpielKopf({
  label = "Runde",
  wert,
  hinweis,
  pille,
  onVerlauf,
  verlaufAnzahl,
  onMenue,
  menueIcon = "menue",
  menueLabel = "Menü",
}) {
  return (
    <header className="spiel-kopf">
      <div className="spiel-kopf-runde">
        <small>{label}</small>
        <strong>{wert}</strong>
        {hinweis}
      </div>
      {pille}
      {onVerlauf && (
        <button
          type="button"
          className="ikon-knopf"
          onClick={onVerlauf}
          aria-label={verlaufAnzahl ? `Verlauf, ${verlaufAnzahl} Einträge` : "Verlauf"}
          title="Verlauf"
        >
          <Icon name="verlauf" />
        </button>
      )}
      {onMenue && (
        <button type="button" className="ikon-knopf" onClick={onMenue} aria-label={menueLabel} title={menueLabel}>
          <Icon name={menueIcon} />
        </button>
      )}
    </header>
  );
}

export default SpielKopf;
